<template>
  <b-modal centered no-close-on-backdrop no-close-on-esc v-model="modelReceiverShow" @close="closeReceiver"
           size="xl" hide-footer no-stacking>
    <template slot="modal-title" class="w-100">
      <div slot="header" class="bg-white border-0" ref="model-parcel-header">
        <div class="row align-items-center">
          <div class="col-6 d-flex align-items-center">
            <h3 class="mb-0">
              {{JSON.stringify(receiverInfo) === '{}'?'添加收件人':'编辑'}}
              <span>{{ activeCourierItem?activeCourierItem.expressName:receiverInfo.detail.expressCode }}</span>
            </h3>
            <img class="card-img-top img-mx-100 pl-3" :src="activeCourierItem.expressUrl" v-if="activeCourierItem.expressUrl"
                 img-alt="Image" />
          </div>
        </div>
      </div>
    </template>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-form-group
          id="input-group-1"
          label="自定义编码:"
          label-for="input-1"
      >
        <b-form-input
            id="input-1"
            v-model="form.customCode"
            placeholder="Enter CustomCode"
        ></b-form-input>
      </b-form-group>
      <div style="display: flex;align-items: center;justify-content: space-between">
        <b-form-group
            id="input-group-1"
            label="电话:"
            label-for="input-1"
            class="w-100 mr-3"
        >
          <autocomplete
              :search="searchSenderDetails"
              @submit="onSubmitSenders"
              @input="form.recUserMobile = $event.target.value"
              :value="form.recUserMobile"
              ref="sender_tel"
              class="senderTel"
          >
            <template v-slot:result="{ result, props }">
              <li v-bind="props">
                <h6 class="d-flex  align-items-center">
                  {{result.name}} <i class="fas fa-angle-double-right px-1"></i> {{result.type == 0 ?'บุคคลธรรมดา':'นิติบุคคล'}}  <i class="fas fa-angle-double-right px-1"></i>{{result.mobile}} <i class="fas fa-angle-double-right px-1"></i>{{result.postcode}} {{result.district}} {{result.city}} {{result.province}}
                </h6 >
              </li>
            </template>

          </autocomplete>
        </b-form-group>
        <b-form-group
            id="input-group-1"
            label="姓名:"
            label-for="input-1"
            class="w-100 ml-3"
        >
          <b-form-input
              id="input-1"
              v-model="form.recUserName"
              placeholder="Enter Receiver Name"
              required
          ></b-form-input>
        </b-form-group>
      </div>

      <b-form-group id="input-group-2" label="行政区域:" label-for="input-2">
        <autocomplete
            :search="searchRegionList"
            @submit="onSubmitRegion"
            @input="form.region = $event.target.value"
            :value="form.region"
            ref="sender_tel"
            class="senderTel"
        >
          <template v-slot:result="{ result, props }">
            <li v-bind="props">
              <h6 class="d-flex  align-items-center">
                {{result.zipCode}} {{result.district}} {{result.city}} {{result.province}}
              </h6 >
            </li>
          </template>

        </autocomplete>
      </b-form-group>

      <b-form-group id="input-group-3" label="物品类型:" label-for="input-3">
        <b-form-select
            id="input-3"
            v-model="form.parcelCategory"
            :options="typeListOptions"
            value-field="code"
            text-field="name"
            required
        >

        </b-form-select>

      </b-form-group>
      <b-form-group
          id="input-group-1"
          label="重量(kg):"
          label-for="input-1"
          class="w-100"
      >
        <b-form-input
            id="input-1"
            v-model="form.weight"
            placeholder="Enter weight"
            required
        ></b-form-input>
      </b-form-group>
      <b-form-group
          id="input-group-1"
          label="尺寸(kg):"
          label-for="input-1"
          class="w-100 mb-0"
      >
        <div style="display: flex;align-items: center;justify-content: space-between">
          <b-form-group
              id="input-group-1"
              label=" "
              label-for="input-1"
              class="w-100"
          >
            <b-form-input
                id="input-1"
                v-model="form.width"
                placeholder="Enter width"
                required
            ></b-form-input>
          </b-form-group>
          <b-form-group
              id="input-group-1"
              label=" "
              label-for="input-1"
              class="w-100 ml-3"
          >
            <b-form-input
                id="input-1"
                v-model="form.length"
                placeholder="Enter length"
                required
            ></b-form-input>
          </b-form-group>
          <b-form-group
              id="input-group-1"
              label=" "
              label-for="input-1"
              class="w-100 ml-3"
          >
            <b-form-input
                id="input-1"
                v-model="form.height"
                placeholder="Enter height"
                required
            ></b-form-input>
          </b-form-group>
          <b-button variant="primary" class="ml-3 mb-3">Select</b-button>
        </div>
      </b-form-group>
      <div style="display: flex;align-items: center;justify-content: space-between">
        <b-form-group
            id="input-group-1"
            label="COD:"
            label-for="input-1"
            :class="codInfoOptions.length > 0?'w-50':'w-100'"
        >
          <b-form-input
              id="input-1"
              v-model="form.codAmount"
              placeholder="Enter codAmount"
              @input="fngetCodInfoList"
              :class="{ 'is-invalid': getCodError }"
          ></b-form-input>
          <div v-if="getCodError" class="invalid-feedback">
            该用户不支持COD</div>
        </b-form-group>
        <b-form-group id="input-group-3" label="COD账户:" :style="form.codAmount?'width:45%':''" label-for="input-3" v-if="codInfoOptions.length > 0">
          <b-form-select
              id="input-3"
              v-model="form.selectCodInfo"
              required
              class="w-100"
              @change="changCod"
          >
            <option v-for="option in codInfoOptions" :value="option">
              {{ option.name }}-{{option.mobile}}-{{option.codAccountId}}
            </option>
          </b-form-select>
        </b-form-group>
      </div>
      <div style="display: flex;align-items: center;justify-content: space-between">
        <b-form-group
            id="input-group-1"
            label="物品声明价格:"
            label-for="input-1"
            class="w-100"
        >
          <b-form-input
              id="input-1"
              v-model="form.parcelPrice"
              placeholder="Enter parcelPrice"
              @input="getInsuranceList"
              :class="{ 'is-invalid': getInsuranceError }"
          ></b-form-input>
          <div v-if="getInsuranceError" class="invalid-feedback">
            该快递公司无可用保险</div>
        </b-form-group>
        <b-form-group id="input-group-3" label=" " :style="form.parcelPrice?'width:45%':''" label-for="input-3" v-if="insuranceInfoOptions.length > 0">
          <b-form-select
              id="input-3"
              v-model="form.selectInsuranceInfo"
              required
              class="w-100"
              @change="selectInsurance"
          >
            <option v-for="option in insuranceInfoOptions" :value="option">
              {{ option.insuranceCompanyName }}-{{option.insuranceCompanyId}}
            </option>
          </b-form-select>
        </b-form-group>
      </div>


      <b-form-group id="input-group-4" v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
            v-model="isSpeed"
            id="checkboxes-4"
            @change="changeSpeed"
            :aria-describedby="ariaDescribedby"
        >
          <b-form-checkbox :value="true">SPEED</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-form-group
          id="input-group-1"
          label="Remark:"
          label-for="input-1"
          class="w-100"
      >
        <b-form-textarea
            id="input-1"
            v-model="form.remark"
            type="text"
            placeholder="Enter remark"
        ></b-form-textarea>
      </b-form-group>

      <b-button type="submit" variant="primary">Submit</b-button>
      <b-button type="reset" variant="danger">Reset</b-button>
    </b-form>
  </b-modal>
</template>
<script>
import {
  getAgentUserAddress,
  saveOrUpdatePkgInfoV3,
  getPkgCategory,
  getReginListByKeyWords,
  getCodInfoList, querySupportInsureCompanyList
} from "@/api/express";
import moment from "moment";
import AutocompletesAddress from "@/components/Autocomplete/AddressTH/AutocompleteAddressTH.vue";

export default {
  components: {AutocompletesAddress},
  props:{
    activeCourierItem:{
      type:Object,
      default:() => {}
    },
    cashNumberInfo:{
      type:Object,
      default:() => {}
    },
    fnGetPosRecentlyList:Function
  },
  data(){
    return {
      modelReceiverShow:false,
      form: {
        customCode:'',
        recUserName:'',
        recUserMobile:'',
        recAddress:'',
        recDistrict:'',
        recCity:'',
        recProvince:'',
        recAreaCode:'',
        recPostCode:'',
        weight: '',
        length: '',
        width: '',
        height:'',
        parcelType:'',
        parcelCategory:'',
        parcelDesc:'',
        codAmount:'',
        parcelPrice:'',
        isSpeed:false,
        codInfoId:'',
        insuranceCompanyId:'0',
        userFreightDiscountId:'0',
        batchNum:'0',
        prizeCode:'',
        region:'',
        selectCodInfo:{},
        selectInsuranceInfo:{}
      },
      typeListOptions: [],
      codInfoOptions:[],
      insuranceInfoOptions:[],
      show: true,
      selectSender:{},
      receiverInfo:{},
      getCodError:false,
      getInsuranceError:false,
      isSpeed:undefined,
    }
  },
  methods:{
    async fnGetPkgCateGory() {
      let params = {
        country:'TH',
        category:0
      }
      let res = await getPkgCategory(params)
      this.typeListOptions = res.data
    },
    // 获取快递公司对应保险服务
    getInsuranceList() {
      let params = {
        pkgPrice:this.form.parcelPrice,
        expressCode:this.activeCourierItem.expressName?this.activeCourierItem.expressName:this.receiverInfo.detail.expressCode
      }
      querySupportInsureCompanyList(params)
          .then((res) => {
            if (res.data.length > 0){
              this.getCodError = false
              this.insuranceInfoOptions = res.data
            }else{
              this.getCodError = true
            }
          })
    },
    // 获取COD信息
    fngetCodInfoList(){
      console.log(this.activeCourierItem)
      let params = {
        mobile: this.selectSender.tel,
        expressCode:this.activeCourierItem.expressName?this.activeCourierItem.expressName:this.receiverInfo.detail.expressCode
      }
      getCodInfoList(params)
          .then((res) => {
            if (res.data.length > 0){
              this.getCodError = false
              this.codInfoOptions = res.data
            }else{
              this.getCodError = true
            }
      })
    },
    changCod(value){
      this.form.selectCodInfo = value
      this.form.codInfoId = value.id?value.id:value.codAccountId
    },
    selectInsurance(value){
      this.form.selectInsuranceInfo = value
      this.form.insuranceCompanyId = value.insuranceCompanyId
    },
    changeSpeed(value){
      console.log(value)
      if (value.length > 0){
        this.form.isSpeed = value[0]
      }
    },
    closeReceiver(){
      this.modelReceiverShow = false
      this.$emit('showAddParcelInfo')
    },
    showAddReceiverInfo(item){
      console.log(item)
      this.fnGetPkgCateGory()
      if (item){
        this.receiverInfo = item
        this.form.customCode= ''
        this.form.id = this.receiverInfo.detail.id
        this.form.recUserName= this.receiverInfo.detail.receiverName
        this.form.recUserMobile= this.receiverInfo.detail.receiverPhone
        this.form.recAddress= this.receiverInfo.detail.receiverAddress
        this.form.recDistrict= this.receiverInfo.detail.receiverDistrict
        this.form.recCity= this.receiverInfo.detail.receiverCity
        this.form.recProvince= this.receiverInfo.detail.receiverProvince
        this.form.recAreaCode= this.receiverInfo.detail.receiverArea
        this.form.recPostCode= this.receiverInfo.detail.receiverPostcode
        this.form.weight= this.receiverInfo.detail.pkgWeight
        this.form.length= this.receiverInfo.detail.pkgLenght
        this.form.width= this.receiverInfo.detail.pkgWidth
        this.form.height= this.receiverInfo.detail.pkgHeight
        // this.form.parcelType= this.receiverInfo.detail.receiverName
        this.form.parcelCategory= this.receiverInfo.detail.pkgCategory
        this.form.parcelDesc= this.receiverInfo.detail.pkgDesc
        this.form.codAmount= this.receiverInfo.detail.codAmount
        this.form.parcelPrice= this.receiverInfo.detail.insureAmount
        this.form.isSpeed= this.receiverInfo.detail.isSpeed
        this.form.codInfoId= '0'
        this.form.insuranceCompanyId= '0'
        this.form.userFreightDiscountId='0'
        this.form.batchNum='0'
        this.form.prizeCode=''
        this.form.region= this.receiverInfo.detail.receiverPostcode + '-'+
            this.receiverInfo.detail.receiverDistrict+ '-'+
            this.receiverInfo.detail.receiverCity+ '-'+
            this.receiverInfo.detail.receiverProvince
      }else{
      }
      this.selectSender = JSON.parse(localStorage.getItem('senderInfo'))
      console.log(this.selectSender)
      this.modelReceiverShow = true
    },
    onSubmit(event) {
      event.preventDefault();
      let params = {
        ...this.form,
        expressCode:this.activeCourierItem.expressName?this.activeCourierItem.expressName:this.receiverInfo.detail.expressCode,
        srcUserName:this.selectSender.name,
        srcUserMobile:this.selectSender.tel,
        srcAddress:this.selectSender.address,
        srcDistrict:this.selectSender.district,
        srcCity:this.selectSender.state,
        srcProvince:this.selectSender.province,
        srcAreaCode:this.selectSender.areaCode,
        srcPostCode:this.selectSender.postcode,
        parcelType:1,
        cashNum:this.$store.state.cashNum,
        // insuranceCompanyId:this.activeCourierItem.insuranceCompanyId || 0,
        userFreightDiscountId:this.activeCourierItem.freightDiscountId || '0',
      }
      console.log(params)
      saveOrUpdatePkgInfoV3(params)
          .then((res) => {
            this.modelReceiverShow = false
            this.$emit('showAddParcelInfo')
            if (this.form.id){
              this.$emit('fnGetPosRecentlyList')
            }
          })
    },
    onReset(event) {
      event.preventDefault()
      // Reset our form values
      this.form.email = ''
      this.form.name = ''
      this.form.food = null
      this.form.checked = []
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    searchSenderDetails(value){
      let params = {
        mobile:value,
        pageIndex:1,
        pageSize:10,
      }
      const TIME = 500;
      let setTime
      return new Promise((resolve) => {
        if (value.length < 3) {
          return resolve([]);
        }
        if (isNaN(value)) {
          return resolve([]);
        }
        clearTimeout(setTime);
        setTime = setTimeout(function() {
          console.log('11111')
          getAgentUserAddress(params)
              .then((res) => {
                console.log(res.data.records)
                resolve(res.data.records)
              })
        }, TIME);
      });
    },
    searchRegionList(value){
      const TIME = 500;
      let setTime
      return new Promise((resolve) => {
        if (value.length < 3) {
          return resolve([]);
        }
        if (isNaN(value)) {
          return resolve([]);
        }
        clearTimeout(setTime);
        setTime = setTimeout(function() {
          console.log('11111')
          getReginListByKeyWords(value)
              .then((res) => {
                console.log(res.data)
                resolve(res.data)
              })
        }, TIME);
      });
    },
    onSubmitRegion(result) {
      console.log(result)
      this.form.region = result.zipCode + '-' +result.district + '-' + result.city+ '-' + result.province
      this.form.recCity = result.city
      this.form.recDistrict = result.district
      this.form.recProvince = result.province
      this.form.recPostCode = result.zipCode
      this.form.recAreaCode = result.originCode
    },
    onSubmitSenders(result) {
      console.log(result)
      this.form.recUserMobile = result.mobile
      this.form.recUserName = result.name
      this.form.recAddress = result.adress
      this.form.recCity = result.city
      this.form.recDistrict = result.district
      this.form.recProvince = result.province
      this.form.recPostCode = result.postcode
      this.form.recAreaCode = result.areaCode
      this.form.region = result.postcode+'-'+result.district+'-'+result.city+'-'+result.province

    },
    // 获取地址列表信息
    async onSubmitAddress(ads, objKey) {
      console.log(ads, objKey)

      Object.keys(this[objKey]).forEach(key => {
        if (ads[key]) {
          this[objKey][key] = ads[key]
        } else if (key == 'state') {
          this[objKey]['state'] = ads['sub-district']
        }
        else {
          this[objKey][key] = this[objKey][key]
        }
      })

      if (objKey == 'to') {
        this.checkDestinationCourier()
        await this.callCheckProblemCategory()
      }

    },
  }
}
</script>
